<template>
  <div class="columns">
    <div class="width-100 div-p">
      <p class="text-center p-titles">{{theme.title}}</p>
      <div class="plr-10">
        <div class="line-blue mb-1 mt-3 text-center">
          <div class="ma-10 mt-2 columns">
            <div class="mt-2 inline-block column is-half">
              <p class="p-titles">
                <a :href="theme.supporting_text_url" target="_blank">
                  Texto de apoio
                  <em class="fas fa-file-pdf icon-color"></em>
                </a>
              </p>
            </div>
            <div class="mt-2 inline-block column is-half">
              <p class="p-titles">
                <a :href="theme.propose_url" target="_blank">
                  Competências
                  <em class="fas fa-file-pdf icon-color"></em>
                </a>
              </p>
            </div>
            <div class="column is-2">
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ThemeService from '@/services/theme/theme'
import Notification from '@/support/mixins/notifications.mixin'
export default {
  props: {
    themeId: {
      required: true
    }
  },
  mixins: [Notification],
  data () {
    return {
      theme: {},
      supportMaterial: [],
      ThemeService: new ThemeService()
    }
  },
  mounted () {
    this.loadInfoTheme(this.themeId)
  },
  methods: {
    async loadInfoTheme (themeId) {
      try {
        const { data } = await this.ThemeService.get(themeId)
        this.theme = data
      } catch (error) {
        this.errorMsg('Temas', error.message, 'topCenter')
      }
    }
  }
}
</script>
<style scoped>
.line-blue {
  border-top: 2px solid #0079be;
}
.div-p {
  background-color: #e0e9f2;
  border-radius: 15px;
}
.p-titles {
  font-size: 25px;
  font-weight: 500;
  color: #0079be;
}
.icon-color {
  color: red;
}
</style>
